import { create } from 'zustand'
import { CountriesListResponse, CountryType } from '@/types/country'
import { fetchCountries } from '@/lib/api'
import { getErrorMessage } from '@/lib/utils'

type CountriesState = {
  countries: CountryType[]
  isLoading: boolean
  error: string | null
  setCountries: (countries: CountryType[]) => void
  setIsLoading: (isLoading: boolean) => void
  setError: (error: string | null) => void

  // API functions
  fetchCountriesList: () => Promise<CountriesListResponse>
  resetCountriesList: () => void
}

const useCountriesStore = create<CountriesState>(set => ({
  countries: [],
  isLoading: false,
  error: null,
  setCountries: countries => set({ countries }),
  setIsLoading: isLoading => set({ isLoading }),
  setError: error => set({ error }),

  fetchCountriesList: async () => {
    set({ isLoading: true, error: null })

    try {
      const data = await fetchCountries()

      set({
        countries: data,
        isLoading: false
      })

      return data
    } catch (error) {
      const errorMessage = getErrorMessage(error)

      set({
        error: errorMessage,
        isLoading: false
      })

      throw error
    }
  },

  resetCountriesList: () => {
    set({
      countries: [],
      error: null
    })
  }
}))

export default useCountriesStore
